import React from 'react';

interface IPropsIconeMovimentosCnj {
    width?: string | number;
    height?: string | number;
    fill?: string;
    style?: React.CSSProperties;
}

const IconeMovimentosCnj: React.FC<IPropsIconeMovimentosCnj> = ({ width = 24, height = 24, fill = '#9a9a9a', style }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 140" width={width} height={height} style={style}>
            <g fill={fill}>
                {/* Seta Superior (Direita) */}
                <path d="M 60 38 L 98 38 L 98 26 L 118 50 L 98 74 L 98 62 L 60 62 C 55.6 62 52 58.4 52 54 L 52 46 C 52 41.6 55.6 38 60 38 Z" />
                {/* Seta Inferior (Esquerda) */}
                <path d="M 105 78 L 67 78 L 67 66 L 47 90 L 67 114 L 67 102 L 105 102 C 109.4 102 113 98.4 113 94 L 113 86 C 113 81.6 109.4 78 105 78 Z" />
                {/* Engrenagem */}
                <path fillRule="evenodd" d="M 152,70 m -24,0 a 24,24 0 1,0 48,0 a 24,24 0 1,0 -48,0 Z M 152,70 m -11,0 a 11,11 0 1,1 22,0 a 11,11 0 1,1 -22,0 Z" />
                {/* Dentes da Engrenagem */}
                <rect x="146" y="41" width="12" height="9" rx="2.5" />
                <rect x="146" y="90" width="12" height="9" rx="2.5" />
                <rect x="168" y="53" width="12" height="9" rx="2.5" transform="rotate(60 174 57.5)" />
                <rect x="168" y="78" width="12" height="9" rx="2.5" transform="rotate(120 174 82.5)" />
                <rect x="124" y="78" width="12" height="9" rx="2.5" transform="rotate(60 130 82.5)" />
                <rect x="124" y="53" width="12" height="9" rx="2.5" transform="rotate(120 130 57.5)" />
            </g>
        </svg>
    );
};

export default IconeMovimentosCnj;
